module.exports = __webpack_public_path__ + "img/espresso-martini.292a641f.jpg";